import React, { FC } from 'react';

import { DayDatePicker, MonthDatePicker } from '.';
import { weekdayLocal, isSameDayLocal } from '../../../shared/lib/time';

export const DAY_MILLIS = 24 * 60 * 60 * 1000;

export type DatePickerMode = 'month' | 'day';

export interface DatePickerProps {
  selectedDate: Date;
  startDate: Date;
  onSelectedDateChange: (date: Date) => void;
  onStartDateChange: (date: Date) => void;
  onSailingsButtonClick: () => void;
  onModeChange: (newMode: DatePickerMode) => void;
  mode: DatePickerMode;
}

export interface DatePickerDayInfo {
  date: Date;
  dayOfMonth: number;
  dayOfWeek: string;
  selected: boolean;
}

export function dateToDayInfo(date: Date, selectedDate: Date): DatePickerDayInfo {
  return {
    date,
    dayOfMonth: date.getDate(),
    dayOfWeek: weekdayLocal(date),
    selected: isSameDayLocal(date, selectedDate),
  };
}

export function addStartDays(date: Date, days: number): Date {
  let time = date.getTime();
  return new Date(time + days * DAY_MILLIS);
}

export function subtractStartDays(date: Date, days: number): Date {
  let time = date.getTime();
  return new Date(time - days * DAY_MILLIS);
}

const DatePicker: FC<DatePickerProps> = props => {
  return (
    <div>
      <button
        onClick={() => props.onModeChange(props.mode === 'month' ? 'day' : 'month')}
        className="w-full flex justify-center bg-blue-lighter items-center"
        style={{ minHeight: 20 }}
      >
        {props.mode === 'day' ? (
          <div className="bg-grey-lighter rounded" style={{ width: 30, height: 4 }} />
        ) : (
          <span className="py-2 text-white">Close</span>
        )}
      </button>
      {props.mode === 'month' ? <MonthDatePicker {...props} /> : <DayDatePicker {...props} />}
    </div>
  );
};

export default DatePicker;
